import React, { useEffect, useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import profile_icon from "../../assets/profile_icon.jpg";
import userProfile from "../../assets/userProfile.jpg";
import axios from "axios";
import { BASE_URL } from "../../helper/api_helper";
import toast from "react-hot-toast";
const SupportComponent = ({ masterData }) => {
  const [activeTab, setActiveTab] = useState("");
  const [supportList, setSupportList] = useState([]);
  const [selectedChat, setSelectedChat] = useState();
  const [newMessage, setNewMessage] = useState();

  const [search, setSearch] = useState("");
  const [chatMessages, setChatMessages] = useState([]);

  const getSupportListMasterAdmin = async () => {
    try {
      let body = { status: activeTab, search: search };
      let response = await axios.post(
        `${BASE_URL}/support/get-all-customer-supports`,
        body
      );
      if (response.status === 200) {
        setSupportList(response.data);
        // Don't auto-select a chat while user is actively searching.
        if (search && search.trim() !== "") {
          setSelectedChat(undefined);
        } else {
          setSelectedChat(response.data[0]);
        }
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
  useEffect(() => {
    getSupportListMasterAdmin();
  }, [activeTab, search]);
  const handleIndividualClick = (item) => {
    setSelectedChat(item);
  };
  const getSupportMessages = async () => {
    try {
      let body = { support_id: selectedChat.id };
      let response = await axios.post(
        `${BASE_URL}/support/get-all-customer-support-messages`,
        body
      );
      if (response.status === 200) {
        setChatMessages(response.data);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
  useEffect(() => {
    if (selectedChat) {
      getSupportMessages();
    }
  }, [selectedChat]);
  function formatTo12HourTime(isoDateStr) {
    const date = new Date(isoDateStr);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const suffix = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const paddedMinutes = minutes.toString().padStart(2, "0");
    return `${hours}:${paddedMinutes} ${suffix}`;
  }
  const handleCloseSupport = async () => {
    try {
      if (!selectedChat) {
        toast.error("Chat id not found");
        return;
      }
      let body = { support_id: selectedChat.id };
      let response = await axios.post(`${BASE_URL}/support/close-support`, body);

      if (response.status === 200) {
        getSupportListMasterAdmin();
      }
    } catch (error) {}
  };
  const handleSendMessage = async () => {
    try {
      let body = {
        support_id: selectedChat.id,
        message: newMessage,
        is_replied_by_admin: true,
      };
      let response = await axios.post(`${BASE_URL}/support/add-message`, body);

      if (response.status === 200) {
        getSupportMessages();
        setNewMessage("");
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Support" />
      <div className="chat-wrapper">
        <div className="chat-sidebar card">
          <div className="chat-sidebar-single active top-profile">
            <div className="img">
              <img src={profile_icon} alt="image_icon" />
            </div>
            <div className="info">
              <h6 className="text-md mb-0">{masterData?.username}</h6>
              <p className="mb-0">{masterData?.email}</p>
            </div>
          </div>
          <div className="chat-search">
            <span className="icon">
              <Icon icon="iconoir:search" />
            </span>
            <input
              type="text"
              name="#0"
              autoComplete="off"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search..."
            />
          </div>
          <div className="chat-all-list">
            {supportList?.map((items, index) => {
              const isActive = selectedChat && selectedChat.id === items.id;
              return (
                <div
                  className={`chat-sidebar-single chat-active${
                    isActive ? " active" : ""
                  }`}
                  key={index}
                  onClick={() => handleIndividualClick(items)}
                >
                  <div className="">
                    <img
                      src={userProfile}
                      style={{ height: "40px", borderRadius: "50%" }}
                      alt="image_icon"
                    />
                  </div>
                  <div className="info">
                    <h6 className="text-sm mb-1">{items?.fullName}</h6>
                    <p
                      className="mb-0 text-xs"
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 120,
                      }}
                    >
                      {items?.subject}
                    </p>
                  </div>
                  <div className="action text-end">
                    {items?.status === "OPEN" ? (
                      <span className="bg-success-focus text-success-main px-20 py-4 rounded-pill fw-medium text-sm">
                        OPEN
                      </span>
                    ) : items.status === "CLOSED" ? (
                      <span className="bg-danger-focus text-danger-main px-12 py-4 rounded-pill fw-medium text-sm">
                        CLOSED
                      </span>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {(search.trim() === "" || selectedChat) ? (
          <div className="chat-main card">
            <div className="chat-sidebar-single active">
              <div className="d-flex align-items-center gap-3">
                <img
                  src={userProfile}
                  style={{ height: "40px", width: "40px", borderRadius: "50%" }}
                  alt="image_icon"
                />
                <div className="info" style={{ minWidth: 0 }}>
                  <h6 className="text-md mb-0">{selectedChat?.fullName}</h6>
                  <p className="mb-0">{selectedChat?.email}</p>
                  {selectedChat?.subject && (
                    <p className="mb-0 text-xs fw-semibold text-primary-light">
                      Subject: {selectedChat.subject}
                    </p>
                  )}
                </div>

                {selectedChat?.status === "OPEN" && (
                  <div className="action d-inline-flex align-items-center gap-3">
                    <div className="btn-group">
                      <button
                        type="button"
                        className="text-primary-light text-xl"
                        data-bs-toggle="dropdown"
                        data-bs-display="static"
                        aria-expanded="false"
                      >
                        <Icon icon="tabler:dots-vertical" />
                      </button>
                      <ul className="dropdown-menu dropdown-menu-lg-end border">
                        <li>
                          <button
                            className="dropdown-item rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 d-flex align-items-center gap-2"
                            type="button"
                            onClick={handleCloseSupport}
                          >
                            <Icon icon="mdi:clear-circle-outline" />
                            Close Support
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* If no chat is selected show empty state, otherwise show messages */}
            {!selectedChat ? (
              <div className="empty-state p-5 text-center">
                <p className="mb-1 fw-semibold">No chat selected</p>
                <p className="mb-0 text-xs text-muted">
                  Select a conversation from the left to view messages.
                </p>
              </div>
            ) : (
              <>
                <div className="chat-message-list">
                  {chatMessages.map((item, index) => {
                    if (!item.message) return null;

                    const isAdmin = item.is_replied_by_admin;

                    return (
                      <div
                        key={index}
                        className={`chat-single-message ${isAdmin ? "right" : "left"}`}
                      >
                        <div className="chat-message-content">
                          <p className="mb-3">{item.message}</p>
                          <p className="chat-time mb-0">
                            <span>{formatTo12HourTime(item.createAt)}</span>
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {selectedChat?.status === "OPEN" && (
                  <form
                    className="chat-message-box"
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSendMessage();
                    }}
                  >
                    <input
                      type="text"
                      name="chatMessage"
                      placeholder="Write message"
                      value={newMessage}
                      onChange={(e) => setNewMessage(e.target.value)}
                    />
                    <div className="chat-message-box-action">
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center gap-1"
                      >
                        Send
                        <Icon icon="f7:paperplane" />
                      </button>
                    </div>
                  </form>
                )}
              </>
            )}
          </div>
        ) : (
          <div className="chat-main card">
            <div className="empty-state p-5 text-center">
              <p className="mb-1 fw-semibold">Nothing to show</p>
              <p className="mb-0 text-xs text-muted">Clear the search to view chats.</p>
            </div>
          </div>
        )}
      </div>
    </MasterLayout>
  );
};

export default SupportComponent;
